import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

class CAMCFundFees {
    constructor(fundCode) {
        this.httpClient = new HttpClient();
        this.fundCode = fundCode;
        this.$root = null;
    }

    async render() {
        const feesData = await this.getFundFeeData();
        if (this.$root && this.$root.attr("category") == "MRF") {
            this.renderMRFFees(feesData);
        } else {
            this.renderSubscriptionRate(feesData);
            this.renderPurchasingRate(feesData);
            this.renderRedemptionRate(feesData);
            this.renderManageFee(feesData);
        }
    }

    async getFundFeeData() {
        const feesUrl = FUND_API_SOURCES.CHARGES_SOURCE + this.fundCode;
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
        };
        const fundFeesData = await this.httpClient.get(feesUrl, options);
        return fundFeesData.data;
    }

    milliFormat(x) {
        // function used to format cash with a precision of 2
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    formatFeesValue(value) {
        value = value.toString();
        var dotPosition = value.indexOf(".") + 1;
        let dotBackStr = value.substring(dotPosition);
        return dotPosition ? (dotBackStr.length >= 2 ? value : value + "0") : Number(value).toFixed(2);
    }

    renderSubscriptionRate(feesData) {}

    renderPurchasingRate(feesData) {}

    renderRedemptionRate(feesData) {}

    renderManageFee(feesData) {}

    renderPensionHeader(headerContext) {}

    renderFeesDescription(descriptionContext) {}

    renderMRFPurchasingRate(feesData) {}

    renderMRFRedemptionRate(feesData) {}

    renderMRFOtherFee(feesData) {}

    errorHandler() {}
}

export default CAMCFundFees;
